/**
 * An on/off switch, for a setting that is genuinely one or the other and
 * takes effect as a state ("reminders are on"), not as an item ticked in a
 * list. A real `role="switch"` button: Space and Enter flip it, a screen
 * reader says "on" or "off", and the word is on the screen as well, so the
 * state is never carried by color or position alone.
 */
import styles from './Switch.module.css';

export function Switch({ checked, onChange, disabled = false, labelledBy, describedBy, onText = 'On', offText = 'Off' }: {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** The id of the visible label. */
  labelledBy: string;
  describedBy?: string;
  onText?: string;
  offText?: string;
}) {
  return (
    <span className={styles.wrap}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-labelledby={labelledBy}
        aria-describedby={describedBy}
        disabled={disabled}
        className={styles.track}
        onClick={() => onChange(!checked)}
      >
        <span className={styles.thumb} aria-hidden="true" />
      </button>
      <span className={styles.state} aria-hidden="true">{checked ? onText : offText}</span>
    </span>
  );
}
